module.exports = __webpack_public_path__ + "src/assets/textures/env/wagon/wagon_axel_256_bake.png";